import * as Layout from './layout/layout.actions';
import * as Manifest from './manifest/manifest.actions';
import * as MessageManifest from './message-manifest/message-manifest.actions';
import * as Modal from './modal/modal.actions';
import * as Rest from './rest/rest.actions';
import * as Theme from './theme/theme.actions';
import * as Wysiwyg from './wysiwyg/wysiwyg.actions';

export const actions = {
  Layout,
  Manifest,
  MessageManifest,
  Modal,
  Rest,
  Theme,
  Wysiwyg
};
